import {
  SwipeableDrawer as SwipeableDrawerBase,
  type SwipeableDrawerProps,
} from "@mui/material";

type Props = Pick<
  SwipeableDrawerProps,
  "open" | "onClose" | "disableRestoreFocus" | "children" | "ModalProps"
> & {
  hasFullHeight?: boolean;
  heightOffset?: number;
  backgroundColor?: string;
};

export function SwipeableDrawer({
  children,
  hasFullHeight,
  heightOffset = 0,
  backgroundColor,
  ...rest
}: Props) {
  const heightOffsetWithUnit = `${heightOffset}px`;

  const heightStyle = hasFullHeight
    ? `calc(100dvh - ${heightOffsetWithUnit})`
    : "auto";

  return (
    <SwipeableDrawerBase
      anchor="bottom"
      onOpen={() => {}} // required prop, but we don't need to do anything on open
      sx={{
        "& .MuiDrawer-paper": {
          height: heightStyle,
          backgroundColor,
        },
      }}
      {...rest}
    >
      {/* puller */}
      <div className="mx-auto -mt-4 mb-4 h-1 w-10 shrink-0 rounded-full bg-stroke-neutral-soft" />
      {children}
    </SwipeableDrawerBase>
  );
}
